/* eslint-disable security/detect-object-injection */
import { on } from 'delegated-events';
import abort from '../../../javascripts/utils/abort';
import onLoad from '../../../javascripts/utils/onLoad';

const updateAddressFields = ($countrySelect: HTMLSelectElement) => {
  const { value: country } = $countrySelect;

  const $address = $countrySelect.closest<HTMLElement>('.address') ?? abort();
  const $administrativeArea = $address.querySelector<HTMLSelectElement>('select[data-address-administrative-area]')
    ?? abort();

  const $administrativeAreaSelectOption = $administrativeArea.options[0];

  const administrativeAreas: Record<string, Record<string, string>> = JSON.parse(
    $address.dataset.addressAdministrativeAreas ?? abort(),
  );

  $administrativeArea.querySelectorAll('option').forEach(($option) => {
    if ($option !== $administrativeAreaSelectOption) {
      $option.remove();
    }
  });

  if (administrativeAreas[country]) {
    Object.entries(administrativeAreas[country]).forEach(([value, label]) => {
      const $option = document.createElement('option');
      $option.value = value;
      $option.text = label;

      $administrativeArea.appendChild($option);
    });
  }

  const $fields = $address.querySelectorAll<HTMLInputElement | HTMLSelectElement>('[data-address-field]');
  const usedFields: Record<string, string[]> = JSON.parse($address.dataset.addressUsedFields ?? abort());

  $fields.forEach(($field) => {
    $field.disabled = !usedFields[country]?.includes($field.dataset.addressField ?? '');
    $field.closest('.address__field')?.toggleAttribute('hidden', $field.disabled);
  });
};

on('change', 'select[data-address-country]', (event) => {
  const { currentTarget: $countrySelect } = event;
  updateAddressFields($countrySelect);
});

onLoad<HTMLSelectElement>('select[data-address-country]', ($countrySelect) => {
  updateAddressFields($countrySelect);
});
